import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  formRow: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
    },
  },
  formItem: {
    width: '100%',
    marginTop: 24,
  },
  numberOptionsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
}));
